var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('LogoWrapper',{attrs:{"src":_vm.src,"alt":"Client Logo","max-height":_vm.maxHeight,"max-width":_vm.maxWidth}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }